import { useContext } from 'react';
import { OrderContext } from '../providers/OrderProvider';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => useContext(OrderContext);